<template>
        <!-- 菜单 -->
            <span  @mouseover="hover" @mouseleave="leave" style="display:inline-block;width:100%">
              <svg-icon :icon-class="on+iconClass" ></svg-icon>
                {{title}}
            </span>
</template>
<script>
export default {
  name:"subSpan",
  props:{
    iconClass:{
      type:String,
      required:true
    },
    title:{
      type:String,
      required:true
    },
    selectedKeys:{
      type:String,
      default:'',
    },
    routeItem:{
      type:Array,
      default:()=>{
        return []
      },
    },
  },
  watch:{
    selectedKeys(){
      this.flag = this.routeItem.some((item)=>{
        return  item.name == this.selectedKeys
      });
      this.on = this.flag?'on':'';
    }
  },
  data() {
    return {
      on:'',
      flag:false,
    };
  },
  created(){
    // console.log(12431,this.routeItem);
    
  },
  methods:{
    hover(){
      if (!this.flag) {
        this.on = 'on'
      }
      
    },
    leave(){
      if (!this.flag) {
        this.on = ''
      }
      
    }
  }
};
</script>

<style lang="less" scoped>

.item-title {
  margin-top: 12px;
  color: rgba(56, 56, 56, 1);
  font-size: 18px;
  line-height: 27px;
  text-align: left;
  font-weight: bold;
}
.ant-menu-sub.ant-menu-inline > .ant-menu-item{
  margin-left: 26px;
  margin-right: 26px;
  padding-left: 26px!important;
  overflow: hidden;
  border-radius:4px;
}
.ant-menu-inline .ant-menu-item, .ant-menu-inline .ant-menu-submenu-title {
  width: 212px;
}
.dashboard{
  height:48px;
  line-height:48px; 
  padding-left:24px;
  color:#000000;
  font-size: 16px;
  font-weight:500;
}
.ant-menu-inline .ant-menu-item::after {
    border-right: 0;
}
.ant-layout-header {
    height: 48px; 
    line-height: 48px; 
    background:#FFFFFF;
}
#components-layout-demo-top-side-2{
  height: 100%;
}
#components-layout-demo-top-side-2 .logo {
  width: 120px;
  height: 31px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px 28px 16px 0;
  float: left;
}
.ant-layout-sider{
  border-right: 1px solid rgba(0,0,0,0.06);
}
.right-container{
  min-width: 768px;
}
/deep/.ant-layout-content {
    min-height: auto;
}

.account{
  padding-bottom: 17px;
  border-bottom: 1px solid #e8e8e8;
  span{
    padding-bottom:4px;
  }
}
/deep/.ant-popover-arrow{
  display: none!important;
}
/deep/.ant-popover-inner-content{
  width: 216px;
  height: 130px;
}
/deep/.ant-popover-inner-content{
  padding: 20px 16px;
}

/deep/.ant-layout-header{
  padding-right:24px; 
}
.my-account{
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  line-height:24px;
  .account-alias{
    font-size:16px;
    font-weight:400;
    color:rgba(0,0,0,0.8);
    line-height:24px;
  }
  .account-tel{
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,0.65);
    line-height:22px;
  }
}
</style>
